import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import EditIcon from "@mui/icons-material/Settings";
import { useApiTenant } from "../../../../api/api-tenant";
import { useAlert } from "../../../../services/alert";
export default function StatusColumn({ type, ticket, ticketStatus, isPreview, refreshTableData, }) {
    const { t } = useTranslation();
    const api = useApiTenant();
    const alert = useAlert();
    const [statusDialogOpen, setStatusDialogOpen] = useState(false);
    const [status, setStatus] = useState();
    const [isSavingTicketDetail, setIsSavingTicketDetail] = useState(false);
    const updateTicketStatus = () => {
        setIsSavingTicketDetail(true);
        api.CREATE_ticketDetail(ticket.id, undefined, status.id)
            .then(() => {
            refreshTableData();
            alert.show(t("tickets.tickets-table.status-updated"), "success");
        })
            .catch(error => {
            setIsSavingTicketDetail(false);
            if (error.response && error.response.data && error.response.data.errors) {
                console.error(error.response);
            }
            alert.show(t("tickets.tickets-table.updating-status-error"), "error");
        });
    };
    const resetStatusDialog = () => {
        setStatusDialogOpen(false);
        setIsSavingTicketDetail(false);
        setTimeout(() => {
            setStatus(null);
        }, 300);
    };
    if (!ticketStatus) {
        return null;
    }
    return (_jsxs(Fragment, { children: [_jsx(Chip, { size: "small", label: ticketStatus.name, style: {
                    border: "1px solid " +
                        (ticketStatus.type === "pending"
                            ? "rgba(156, 39, 176, 1)"
                            : ticketStatus.type === "resolved"
                                ? "rgba(76, 175, 80, 1)"
                                : "rgba(37, 64, 146, 1)"),
                    backgroundColor: ticketStatus.type === "pending"
                        ? "rgba(156, 39, 176, 0.2)"
                        : ticketStatus.type === "resolved"
                            ? "rgba(76, 175, 80, 0.2)"
                            : "rgba(37, 64, 146, 0.2)",
                }, onDelete: type !== "history" && !isPreview
                    ? () => {
                        setStatusDialogOpen(true);
                        setStatus(ticketStatus);
                    }
                    : undefined, deleteIcon: type !== "history" && !isPreview ? (_jsx(Tooltip, Object.assign({ arrow: true, placement: "top", 
                    // @ts-ignore
                    title: t("tickets.tickets-table.edit-status") }, { children: _jsx(EditIcon, {}) }))) : undefined }), _jsxs(Dialog, Object.assign({ fullWidth: true, maxWidth: "xs", open: statusDialogOpen, onClose: resetStatusDialog }, { children: [_jsx(DialogContent, Object.assign({ sx: {
                            paddingTop: "32px !important",
                        } }, { children: _jsx(Autocomplete, { options: ticket.campaign.ticket_statuses, getOptionLabel: status => status.name, isOptionEqualToValue: (option, value) => option.id === value.id, value: status, onChange: (event, value) => setStatus(value), renderOption: (props, status) => (_jsx("li", Object.assign({}, props, { children: _jsx(Box, Object.assign({ sx: {
                                        display: "flex",
                                        flexDirection: "column",
                                    } }, { children: _jsx(Box, Object.assign({ sx: {
                                            display: "flex",
                                        } }, { children: _jsx(Typography, { children: status.name }) })) }), status.id) }))), renderInput: params => (_jsx(TextField, Object.assign({}, params, { label: t("tickets.ticket-attributes.status"), required: true, fullWidth: true, InputProps: Object.assign({}, params.InputProps) }))) }) })), _jsxs(DialogActions, { children: [_jsx(Button, Object.assign({ color: "inherit", onClick: resetStatusDialog }, { children: t("cancel") })), _jsx(LoadingButton, Object.assign({ loading: isSavingTicketDetail, loadingIndicator: _jsx(CircularProgress, { color: "inherit", size: 16 }), disabled: !status, onClick: updateTicketStatus }, { children: t("tickets.tickets-table.edit-status") }))] })] }))] }));
}
